export default __webpack_public_path__ + "static/media/BeaconLogoFull.3971167f.svg";